/**
 * remote-resources.js - Dynamic script loading utilities
 *
 * 2025-12-29: Reverted Google Maps API key to hardcoded value
 */

function loadAsyncScript(url, options = {}) {
  const script = document.createElement('script')
  if (options.id) script.id = options.id
  script.setAttribute('async', '')
  script.setAttribute('defer', '')
  script.src = url
  script.onload = options.callback
  document.getElementsByTagName('head')[0].appendChild(script)
}

let isLoadingGoogleMaps = false
let googleMapsPromise = null

function loadGmaps() {
  if (window.google && window.google.maps && window.google.maps.places) {
    return Promise.resolve(window.google)
  }

  if (isLoadingGoogleMaps && googleMapsPromise) {
    return googleMapsPromise
  }

  isLoadingGoogleMaps = true
  googleMapsPromise = new Promise(resolve => {
    const existingScript = document.querySelector(
      'script[src*="maps.googleapis.com"]'
    )

    if (existingScript) {
      const checkLoaded = () => {
        if (window.google && window.google.maps && window.google.maps.places) {
          isLoadingGoogleMaps = false
          resolve(window.google)
        } else {
          setTimeout(checkLoaded, 100)
        }
      }
      checkLoaded()
    } else {
      setTimeout(() => {
        const gmapsKey = 'AIzaSyCzvYaJgsS0jhNhEjzREy_G9Quie3zc7A4'
        loadAsyncScript(
          `https://maps.googleapis.com/maps/api/js?key=${gmapsKey}&libraries=places&language=en`,
          {
            callback: () => {
              isLoadingGoogleMaps = false
              resolve(window.google)
            },
          }
        )
      }, 500)
    }
  })
  return googleMapsPromise
}

export { loadGmaps, loadAsyncScript }
